/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import BarcodeReader from "react-barcode-reader";
import { useMutation } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import Container from "../components/container/Container";
import Banner from "../components/hero/Banner";
import Header from "../components/header/Header";
import SuccessFlash from "../components/flash_message/SuccessFlash";
import ErrorFlash from "../components/flash_message/ErrorFlash";
import FormValidationError from "../components/flash_message/FormValidationError";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import useAuth from "../hooks/useAuth";
import { playBeepingSound } from "../utils/playSound";
import ModalDrop from "../components/modals/ModalDrop";
import ScanError from "../components/scanning-error/ScanError";
import style from "./pages.module.css";
import SolidButton from "../components/buttons/solid-button/SolidButton";

const SetChildren = styled.div`
	margin-top: 18px;
	width: 100%;
`;

const Input = styled.input`
	width: ${(props) => props.width};
	border: 1px solid #d6d6d6;
	color: black;
	font-size: 16px;
	border-radius: 5px;
	height: 40px;
	padding: 0 5px;
`;
const Label = styled.label`
	width: 100%;
	color: #8a8a8a;
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0px;
	text-align: left;
`;
const FormInputControl = styled.div`
	width: 100%;
	margin: 10px 0;
`;

const VerifyPackage = () => {
	const axiosprivate = useAxiosPrivate();
	const location = useLocation();
	const { auth, setLoading } = useAuth();
	const [barcode, setBarcode] = useState("Scan barcode...................");
	const [longitude, setLongitude] = useState("");
	const [latitude, setLatitude] = useState("");
	const [isSuccess, setIsSuccess] = useState(false);
	const [isFail, setIsFail] = useState(false);
	const navigate = useNavigate();
	const [validCount, setValidCount] = useState(0);
	const [isParent, setIsParent] = useState(true);
	const [parent, setParent] = useState("");
	const [children, setChildren] = useState("");
	const [message, setMessage] = useState("Success");
	const [incompleteScan, setIncompleteScan] = useState(false);
	const [scanError, setScanError] = useState({ show: false, barcode: "" });

	useEffect(() => {
		navigator.permissions.query({ name: "geolocation" }).then((resp) => {
			if (resp.state === "granted") {
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(success, error);
				}
			} else if (resp.state === "denied") {
				navigate("/", { state: { from: location }, replace: true });
			}
		});

		function success(position) {
			setLatitude(`${position.coords.latitude}`);
			setLongitude(`${position.coords.longitude}`);
		}

		function error(err) {
			//TASK: remove the lng and lat from the below error log and use them properly or remove them totally
			console.error({ err, latitude, longitude });
			navigate("/", { state: { from: location }, replace: true });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		const isValidInput = parent.trim() !== "" && children.trim() !== "";
		if (isValidInput) {
			handleSubmit();
		}
	}, [parent, children]);

	const validateCode = async (elementString) => {
		const clientId = auth.user.clientId || 4;
		return await axiosprivate.get(
			`/gs1/standard/label/check/${clientId}/${elementString}/pack`,
		);
	};

	//get barcodes
	const handleScan = async (data) => {
		setIncompleteScan(false);
		setBarcode(data);
		setIsFail(false);
		setIsSuccess(false);

		if (isParent) {
			await validateCode(data)
				.then(() => {
					if (
						data.substring(0, 2) === "00" &&
						data.substring(3, 6) === "615"
					) {
						if (data.length < 20) {
							setIncompleteScan(true);
							return;
						} else {
							setParent(data);
							setIsParent(false);
							setBarcode("Scan barcode...................");
							return;
						}
					} else {
						//this means the label is SGTIN
						if (data.length < 40) {
							setIncompleteScan(true);
							return;
						} else {
							setParent(data);
							setIsParent(false);
							setBarcode("Scan barcode...................");
							return;
						}
					}
				})
				.catch((error) => {
					console.error({ error });
					setScanError({
						show: true,
						errorMessage:
							"Parent label is faulty, kindly use another label",
						barcode: data,
					});
					playBeepingSound();
				});
		} else {
			//check if label is SSCC
			if (
				data.substring(0, 2) === "00" &&
				data.substring(3, 6) === "615"
			) {
				if (data.length < 20) {
					setIncompleteScan(true);
					return;
				} else {
					setChildren(data);
					return;
				}
			} else {
				if (data.length < 40) {
					setIncompleteScan(true);
					return;
				} else {
					setChildren(data);
					return;
				}
			}
		}
	};

	//handle error
	function handleError(err) {
		console.error(err);
	}

	//Endpoint to verify pack parent to child pack
	const getPackContent = async (data) => {
		return await axiosprivate.get(
			`/gs1/standard/label/pack/relationship/${data.parentBarCode}/${data.childBarCode}?clientId=${auth.user.clientId || 4}`,
		);
	};

	const resetToParent = () => {
		setIsParent(true);
		setValidCount(0);
		setParent("");
		setChildren("");
		setBarcode("");
	};

	const packContent = useMutation((variables) => getPackContent(variables), {
		onSuccess(data, variables, context) {
			if (data?.data?.message === "Has Relationship") {
				setValidCount((prev) => prev + 1);
			} else {
				setValidCount(0);
				setScanError({
					show: true,
					errorMessage:
						"This item does not belong to this parent package, please remove it.",
					barcode: children,
				});
				playBeepingSound();
			}
		},
		onError(error) {
			setIsParent(true);
			setIsFail(true);
			setBarcode("Scan barcode...................");
			if (error.code === "ERR_NETWORK")
				setMessage("Please Check Your Network");
			else if (
				error?.response?.status === 401 ||
				error?.response?.status === 401
			)
				navigate("/", { state: { from: location }, replace: true });
			else {
				const message = error.response.data.message;
				if (
					message.includes("SQL") ||
					error?.response?.status === 500
				) {
					setMessage("Server Error");
				} else {
					setMessage(message?.replace("Unknow", "Unknown"));
				}
			}
		},
	});

	//handle submit
	const handleSubmit = () => {
		const payload = {
			parentBarCode: parent,
			childBarCode: children,
		};
		packContent.mutate(payload);
	};

	const resetScanError = () => {
		setScanError({ show: false, barcode: "" });
	};

	useEffect(() => {
		setLoading(packContent.isLoading);
	}, [setLoading, packContent.isLoading]);

	const showLabel = parent.trim() !== "";
	const showCountStats = validCount > 0 && !isFail && !isSuccess;

	return (
		<Container>
			{scanError.show && (
				<ModalDrop>
					<ScanError
						onClose={resetScanError}
						barCode={scanError.barcode}
						errorMessage={scanError.errorMessage}
					/>
				</ModalDrop>
			)}
			<Header>{"Verify Package"}</Header>
			<Banner />

			<div>
				<small
					style={{
						fontSize: "12px",
						marginTop: "8px",
						display: "block",
					}}
				>
					Please scan a parent pack first, then scan other packages to
					confirm if the children items are related to the parent.
				</small>
			</div>
			<SetChildren>
				<BarcodeReader
					onError={handleError}
					onScan={handleScan}
					timeBeforeScanTest={1000}
				/>
				<FormInputControl>
					<Label>{isParent ? "Scan Parent" : "Scan Children"}</Label>
				</FormInputControl>
				<FormInputControl>
					<Input
						value={barcode}
						width={"100%"}
						style={{ fontSize: "12px" }}
						disabled
					/>
					{incompleteScan && (
						<FormValidationError
							text={"Incomplete scan.. please rescan!!!!"}
						/>
					)}
				</FormInputControl>
			</SetChildren>

			{showLabel && (
				<div className={style.package_list_item}>
					<p style={{ marginBottom: "6px" }}>Parent label is: </p>
					<p>{parent}</p>
				</div>
			)}

			<FormInputControl style={{ marginTop: "20px" }}>
				<SuccessFlash display={isSuccess}>{message}</SuccessFlash>
			</FormInputControl>

			<FormInputControl style={{ marginTop: "20px" }}>
				<ErrorFlash display={isFail}>{message}</ErrorFlash>
			</FormInputControl>

			<FormInputControl style={{ marginTop: "40px" }}>
				<SuccessFlash
					display={showCountStats}
				>{`Item is a valid content of the parent package`}</SuccessFlash>
			</FormInputControl>

			{showLabel && (
				<SolidButton
					width={"100%"}
					text={"Reset Parent"}
					onclick={resetToParent}
				/>
			)}
		</Container>
	);
};

export default VerifyPackage;
